module.exports = __webpack_public_path__ + "img/infernal_small.f5854679.png";